import React from "react";
import View from "../../view/story/story";

const Presenter: React.FC = () => {
    return <View/>
};

export default Presenter;